import React, { Component } from "react";
import "./Header.scss";
import logo from "../../assets/logo.png";
import { Link, NavLink, withRouter } from "react-router-dom";
import {
  FaBell,
  FaUserCircle,
  FaSignOutAlt,
  FaCog,
  FaHeart,
  FaCommentDots,
} from "react-icons/fa";
import {
  setCurrentLang,
  setCurrentUser,
  setNotificationList,
} from "../../redux/user/user.action";
import { connect } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import { Menu, Dropdown, Badge, Divider } from "antd";
import localization from "../../Localization/Localization.json";
import Avatar from "antd/lib/avatar/avatar";
import {
  setSeenThisNotification,
  userLogout,
} from "../../network/auth.network";
import moment from "moment-hijri";
import { GetAllNotification } from "../../network/home.network";
class Header extends Component {
  state = {
    noBg: false,
    userInHome: false,
  };

  componentDidMount() {
    const { location } = this.props;
    if (location.pathname.includes("/finance")) {
      this.setState({ noBg: true });
    }
    // console.log(location.pathname, "location.pathname");
  }

  // componentDidUpdate(prevProps, prevState) {
  //   const { location } = this.props;
  //   console.log(prevProps, "location.pathname");
  //   console.log(location.pathname, "location.pathname");
  //   if (prevProps?.pathname !== location.pathname) {
  //     this.setState({ userInHome: location.pathname === "/" });
  //   }
  // }

  changeLang = (lang) => {
    // document.getElementsByTagName("html")[0].setAttribute("lang", lang);
    localStorage.setItem("lang", lang);
    this.props.dispatch(setCurrentLang(lang));
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  handelMenuSelect = (val) => {
    if (val.key === "3") {
      userLogout(
        (res) => {
          localStorage.removeItem("tokenCi");
          localStorage.setItem("isAuthenticatedCi", false);
          localStorage.setItem("role", null);
          this.props.dispatch(setCurrentUser(null));
          this.props.history.push("/");
        },
        (error) => {
          //console.log(error);
        }
      );
    }
  };

  handelSetNotifySeen = (id) => {
    console.log(id, "sdafsdf");

    setSeenThisNotification(
      id,
      (res) => {
        GetAllNotification(
          (res) => {
            this.props.dispatch(setNotificationList(res?.data?.model));
            // audioTune.play();
          },
          (err) => {}
        );
      },
      (err) => {
        // message.error("من فضلك حاول مرة أخرى");
      }
    );
  };

  render() {
    const { currentLang, currentUser, location, notification_list } =
      this.props;
    const { noBg, userInHome } = this.state;
    const orderClass = location.pathname.match(
      /\b(?:new-order|finance|orders)\b/gi
    )
      ? "active"
      : "";
    const homeClass = location.pathname.match(/\b(?:search)\b/gi)
      ? "active"
      : "";
    const bondClass = location.pathname.match(/\b(?:bond|new-bond)\b/gi)
      ? "active"
      : "";

    return (
      <div className={`header-wrapper ${noBg && "no-bg"} `}>
        <div className="container">
          <div className="header-content">
            <div className="logo-holder">
              <NavLink exact to="/">
                <img src={logo} alt="logo" />
              </NavLink>
            </div>

            <div className="menu-list-wrapper">
              <ul>
                {/* <li>
                    <NavLink exact className={homeClass} to="/"  activeClassName="active">{localization.home[currentLang]}</NavLink >
                  </li> */}
                <li>
                  <NavLink
                    exact
                    className={homeClass}
                    to="/"
                    activeClassName="active"
                  >
                    {localization.home[currentLang]}
                  </NavLink>
                </li>
                {currentUser && (
                  <>
                    <li>
                      <NavLink
                        exact
                        className={orderClass}
                        to="/orders"
                        activeClassName="active"
                      >
                        {localization.orders[currentLang]}
                      </NavLink>
                    </li>
                  </>
                )}
                <li>
                  <a href="#app-section">عن التطبيق</a>
                </li>
                <li>
                  <a href="#brand-section">
                    {localization.gallary[currentLang]}
                  </a>
                </li>
                <li>
                  <a href="#service-section">
                    {" "}
                    {localization.services[currentLang]}{" "}
                  </a>
                </li>
                <li>
                  <a href="#advantages-section">الميزات</a>
                </li>
                <li>
                  <a href="#contact-section">
                    {" "}
                    {localization.contactUs[currentLang]}
                  </a>
                </li>
              </ul>
            </div>

            <div className="header-action-holder">
              {/* <Link to="/search" className="search-btn-holder"> 
                <FaSearch />
            </Link>  */}
              {currentUser && (
                <div className="search-notify-holder">
                  <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu className="notify-menu-wrapper">
                        {/* CreationDate: "2022-03-19T15:10:55.7709197Z"
                DeletedAt: ""
                Description: ""
                DescriptionLT: ""
                Id: "0"
                IsDeleted: "false"
                ModifiedDate: "2022-03-19T15:10:55.7709869Z"
                NotificationType: ""
                NotificationTypeId: "0"
                ReferenceId: "4"
                Title: ""
                TitleLT: ""
            UserId: "" */}
                        {notification_list?.length >= 1 &&
                          notification_list?.map((notify) => (
                            <Menu.Item
                              key={notify?.Id}
                              onClick={() =>
                                this.handelSetNotifySeen(notify?.Id)
                              }
                              className={notify?.IsSeen ? "seen-bg" : ""}
                            >
                              <Link
                                to={{
                                  pathname: "/client",
                                  state: {
                                    orderId: +notify?.OrderId,
                                  },
                                }}
                                className="notify-row-holder"
                              >
                                <div className="notify-icon-holder">
                                  <FaCommentDots />
                                  {/* <Badge status="error" /> */}
                                </div>
                                <div className="notify-conetnt-holder">
                                  <h4>{notify?.TitleLT}</h4>
                                  <time>
                                    {moment
                                      .utc(
                                        notify?.ModifiedDate ||
                                          notify?.CreationDate
                                      )
                                      .local()
                                      .format("YYYY/M/D  HH:mm:ss")}
                                  </time>
                                  {+notify?.NotificationTypeId === 1 ? (
                                    <Link
                                      to={{
                                        pathname: "/client",
                                        state: {
                                          orderId: +notify?.OrderId,
                                        },
                                      }}
                                    >
                                      عرض الطلب
                                    </Link>
                                  ) : (
                                    <Link
                                      to={{
                                        pathname: "/client",
                                        state: {
                                          orderId: +notify?.OrderId,
                                        },
                                      }}
                                    >
                                      عرض الرساله
                                    </Link>
                                  )}
                                </div>
                              </Link>
                            </Menu.Item>
                          ))}
                      </Menu>
                    }
                  >
                    <Badge
                      size="small"
                      count={
                        notification_list?.filter((s) => !s?.IsSeen)?.length
                      }
                    >
                      <FaBell />
                    </Badge>
                  </Dropdown>
                </div>
              )}

              {Object.keys(currentUser || {}).length > 0 ? (
                <Dropdown
                  overlayClassName="user-dropdown-wrapper"
                  trigger={["click"]}
                  overlay={
                    <Menu onClick={this.handelMenuSelect}>
                      <Menu.Item
                        key="1"
                        style={{ backgroundColor: "transparent" }}
                      >
                        <div className="user-login-wrapper">
                          <Avatar size={60} src="" icon={<UserOutlined />} />
                          <div className="user-auth-info">
                            <p className="user-name">
                              {currentUser?.AspNetUsers?.FullName}
                            </p>
                          </div>
                        </div>
                      </Menu.Item>
                      <Divider />
                      <Menu.Item
                        key="2"
                        icon={<FaUserCircle />}
                        className="brown-color"
                        onClick={() => this.props.history.push("/profile")}
                      >
                        <Link to={`/`}>حسابي الشخصي</Link>
                      </Menu.Item>
                      <Menu.Item
                        key="5"
                        icon={<FaHeart />}
                        className="blue-color"
                        onClick={() => this.props.history.push("/settings")}
                      >
                        <Link to={`/`}>قائمة المفضلة</Link>
                      </Menu.Item>
                      <Menu.Item
                        className="logout-menu-item"
                        key="3"
                        icon={<FaSignOutAlt />}
                      >
                        تسجيل الخروج
                      </Menu.Item>
                    </Menu>
                  }
                  className="login-dropdown"
                >
                  <div className="user-login-wrapper">
                    <Avatar size={32} src="" icon={<UserOutlined />} />
                    <div className="user-auth-info">
                      <p className="user-name">
                        {currentUser?.AspNetUsers?.FullName || ""}
                      </p>
                    </div>
                  </div>
                  {/* <Button type="text"> 
                                {this.props.currentUser?.name || ""}
                            </Button> */}
                </Dropdown>
              ) : (
                <Link to="/signin" className="login-link">
                  تسجيل جديد
                </Link>
              )}

              {/* {currentLang === "en" ? 
                                <p className="lang-holder" onClick={ () => this.changeLang("ar")}>
                                AR
                                </p> : 
                                <p className="lang-holder" onClick={ () => this.changeLang("en")}> 
                                EN
                                </p>
                            } */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const HeaderWithRouter = withRouter(Header);
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentLang: state.user.currentLang,
  notification_list: state.user.notification_list || [],
});

export default connect(mapStateToProps)(HeaderWithRouter);
